/* ••[1]••••••••••••••••••••••••• TestimonialQuote.ts •••••••••••••••••••••••••••••• */

type TestimonialQuote = {
  authorImage: string;
  authorName: string;
  authorOrganization: string;
  quote: string;
  logo: string;
};

function validatedTestimonialQuote(
  testimonialQuote: TestimonialQuote
): TestimonialQuote | null {
  if (
    "authorImage" in testimonialQuote &&
    typeof testimonialQuote.authorImage === "string" &&
    "authorName" in testimonialQuote &&
    typeof testimonialQuote.authorName === "string" &&
    "authorOrganization" in testimonialQuote &&
    typeof testimonialQuote.authorOrganization === "string" &&
    "quote" in testimonialQuote &&
    typeof testimonialQuote.quote === "string" &&
    "logo" in testimonialQuote &&
    typeof testimonialQuote.logo === "string"
  ) {
    return testimonialQuote;
  }

  return null;
}

export { TestimonialQuote, validatedTestimonialQuote };
